// Constants
import { PROOF_INCOME_LANDING_FEATURES_CONFIGURATION } from './constants/proof-income-landing.configuration.constants';
// Enumerations
import { ProofIncomeMethodsEnumeration } from 'containers/proof-income/enumerations/proof-income-methods.enumeration';
// Types
import { LandingOptionsOptionComponentType } from 'components/landing-options/types/landing-options.component.type';
import { ProofIncomeLandingHookType } from '../hooks/types/proof-income-landing.hook.type';
import { ProofIncomeLandingMethodsType } from '../types/proof-income-landing-methods.type';

const getFeaturesProofIncomeConfiguration = ({
  methods,
}: Pick<
  ProofIncomeLandingHookType,
  'methods'
>): LandingOptionsOptionComponentType<ProofIncomeMethodsEnumeration>[] =>
  methods.map(
    ({
      type,
    }: ProofIncomeLandingMethodsType): LandingOptionsOptionComponentType<ProofIncomeMethodsEnumeration> =>
      Object.assign({ type }, PROOF_INCOME_LANDING_FEATURES_CONFIGURATION[type])
  );

export { getFeaturesProofIncomeConfiguration };
